import { ReactElement } from 'react';
import { SearchField, SearchFieldProps } from './SearchField';

type SearchFieldRowProps = Pick<SearchFieldProps, 'onKeyDown'> & {
  value?: string;
  onValueChange: (value: string) => void;
};

export function SearchFieldRow(props: SearchFieldRowProps): ReactElement {
  const p = { ...props };
  return (
    <div className={'w-full p-[8px]'}>
      <SearchField
        aria-label="Search"
        value={p.value}
        onChange={p.onValueChange}
        onKeyDown={p.onKeyDown}
        className={'w-full'}
        placeholder="Search"
        size="small"
        autoFocus
      />
    </div>
  );
}
